

class ServerValidationException extends Error {
    /**
     *
     * @param {Promise} promisedErrors - promise from response.json() function with errors
     * @param {String} code
     */
    constructor(promisedErrors, code=null) {
        super();
        this.name = 'ServerValidationException';
        this.promisedErrors = promisedErrors;
        this.code = code;
    }
}

export default ServerValidationException;


// WEBPACK FOOTER //
// ./web/src/services/ServerValidationException.js